module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/faceWash@3x_6b9d45.png";